import { ChangeDetectionStrategy, Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { SubscriptionPlan } from '@vi-iot/client';
import { SubscriptionPlanTranslationPipe } from '../../pipes/subscription-plan-translation/subscription-plan-translation.pipe';

@Component({
  selector: 'app-booking-package-badge',
  standalone: true,
  templateUrl: './booking-package-badge.component.html',
  styleUrls: ['./booking-package-badge.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [SubscriptionPlanTranslationPipe],
})
export class BookingPackageBadgeComponent implements OnChanges {
  @Input({ required: true }) packageType: SubscriptionPlan;
  @Input() isTrial: boolean; // Cannot be required because dashboard doesn't get trial flag
  @Input() size: 'big' | 'medium' | 'small' | 'inline' = 'big';

  packageName: SubscriptionPlan;

  readonly subscriptionPlan = SubscriptionPlan;

  ngOnChanges(changes: SimpleChanges): void {
    if (
      changes.packageType?.currentValue !== changes.packageType?.previousValue ||
      changes.isTrial?.currentValue !== changes.isTrial?.previousValue
    )
      if (this.isTrial) {
        this.packageName = SubscriptionPlan.Trial;
      } else {
        this.packageName = this.packageType;
      }
  }
}
